<template>
    <v-form>
        <v-card flat class="fill-height">
            <v-layout wrap>
                <v-flex xs12>

                    <v-layout wrap justify-center align-center>
                        <v-flex xs10 md6>
                            <provider-title title="Mi Subscripción"/>
                        </v-flex>
                        <v-flex xs2 md6 class="mt-2 text-xs-right">
                            <div v-if="isOwner">
                                <template
                                    v-if="currentSubscription && (Number(currentSubscription.status) === 1 || Number(currentSubscription.status) === 2)">
                                    <v-btn @click="subscriptionCancelDialog = true" class="hidden-sm-and-down"
                                           color="error" small>
                                        <v-icon size="18" class="mr-1">fa-ban</v-icon>
                                        Cancelar Subscripción
                                    </v-btn>
                                    <v-btn @click="subscriptionCancelDialog = true" class="hidden-md-and-up"
                                           color="error" small fab>
                                        <v-icon>fa-ban</v-icon>
                                    </v-btn>
                                </template>

                                <template
                                    v-if="!currentSubscription || (Number(currentSubscription.status) !== 1 && Number(currentSubscription.status) !== 2)">
                                    <v-btn :disabled="paymentFailed" @click="$refs.planPicker.show()"
                                           class="hidden-sm-and-down" color="primary" small>
                                        <v-icon size="18" class="mr-1">fa-money-check</v-icon>
                                        Contratar plan
                                    </v-btn>
                                    <v-btn @click="$refs.planPicker.show()" class="hidden-md-and-up" color="primary"
                                           small fab>
                                        <v-icon>fa-money-check</v-icon>
                                    </v-btn>
                                </template>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-alert type="warning" color="error" dense :value="planPurchaseNeeded">
                        El periodo de pruebas ha concluído. Es necesario contratar un plan para seguir utilizando
                        <b>{{ appName }}</b>.
                    </v-alert>
                    <v-alert type="warning" color="error" dense :value="paymentFailed">
                        Ha fallado el pago. Debes actualizar tu medio de pago
                    </v-alert>
                    <v-card flat class="kim-card mt-1" v-if="isOwner">

                        <v-card-text class="py-0 text-xs-left">

                            <v-divider class="my-2"></v-divider>

                            <provider-sub-title text="Estado de la subscripción"/>
                            <div>
                                <v-chip outline class="ma-0 px-2" :color="subscriptionStatus.color">
                                    {{ subscriptionStatus.text }}
                                    <v-tooltip top v-if="subscriptionStatus.help">
                                        <template v-slot:activator="{on}">
                                            <v-icon v-on="on" size="18" class="ml-1">mdi-help-circle-outline</v-icon>
                                        </template>
                                        {{ subscriptionStatus.help }}
                                    </v-tooltip>
                                </v-chip>
                            </div>

                            <v-divider class="my-2"></v-divider>

                            <provider-sub-title text="Plan Contratado"/>

                            <template v-if="!subscribedPlan">
                                <div class="body-1">
                                    Aún no has contratado un plan
                                </div>
                            </template>

                            <template v-else>
                                <small>{{ subscribedAt }}</small>
                                <div class="title mt-2">{{ subscribedPlan.name }}</div>
                                <div class="body-1">
                                    {{ subscribedPlan.amount }}{{ subscribedPlan.currency }}<span
                                    class="caption">/mes</span>
                                </div>
                                <div class="mt-2">
                                    <v-btn
                                        v-if="currentSubscription && (Number(currentSubscription.status) === 1 || Number(currentSubscription.status) === 2)"
                                        @click="$refs.planPicker.show()"
                                        color="secondary"
                                        class="my-1 ml-0"
                                        small>
                                        <v-icon size="18" class="mr-1">edit</v-icon>
                                        Cambiar plan
                                    </v-btn>
                                </div>
                            </template>

                        </v-card-text>

                        <v-divider class="my-2"></v-divider>

                        <v-card-text class="py-0 text-xs-left">
                            <provider-sub-title text="Medio de Pago"/>

                            <v-progress-circular
                                color="primary"
                                indeterminate
                                width="2"
                                v-if="refreshingPaymentData">

                            </v-progress-circular>

                            <template v-else-if="card">

                                <v-flex xs12 md6 xl5>
                                    <credit-card
                                        ref="cc"
                                        @deleted="refreshMe"
                                        show-delete-btn
                                        :type="card.type"
                                        :holder="card.holder"
                                        :last4-digits="card.last4Digits"/>
                                </v-flex>

                                <div class="mt-3">
                                    <card-registration-button
                                        v-if="subscribedPlan"
                                        color="secondary"
                                        label="Cambiar medio de pago"
                                        icon="edit"
                                        :plan-id="subscribedPlan.id"
                                        small
                                    />
                                </div>

                            </template>

                            <template v-else>
                                <div class="body-1">
                                    No tienes ningún medio de pago asociado. Contrata un plan para agregar un nuevo
                                    medio de pago.
                                </div>
                            </template>

                        </v-card-text>

                        <v-divider class="my-2"></v-divider>

                        <v-card-text class="py-0 text-xs-left">
                            <div v-if="loadingCities" class="text-xs-center my-5">
                                <v-progress-circular color="primary" indeterminate size="40" width="3"/>
                            </div>
                            <v-form v-else v-model="validForm">
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <provider-sub-title text="Datos DTE"/>
                                    </v-flex>
                                    <v-flex xs12 md6 pa-1>
                                        <v-text-field
                                            prepend-inner-icon="fas fa-id-card"
                                            v-model="dni"
                                            :rules="rules.dni"
                                            label="RUT"
                                            outline
                                        />
                                    </v-flex>
                                    <v-flex xs12 md6 pa-1>
                                        <v-text-field
                                            prepend-inner-icon="fas fa-building"
                                            v-model="businessName"
                                            :rules="rules.businessName"
                                            label="Razón Social"
                                            outline
                                        />
                                    </v-flex>
                                    <v-flex xs12 md6 pa-1>
                                        <v-combobox
                                            prepend-inner-icon="fas fa-city"
                                            v-model="city"
                                            :rules="rules.city"
                                            label="Ciudad"
                                            outline
                                            :items="cities"
                                            item-value="id"
                                            item-text="nombre"
                                            :disabled="loadingCities"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md6 pa-1>
                                        <v-combobox
                                            prepend-inner-icon="fas fa-map-marker-alt"
                                            v-model="commune"
                                            :rules="rules.commune"
                                            label="Comuna"
                                            outline
                                            :items="communes"
                                            item-value="id"
                                            item-text="nombre"
                                            :disabled="loadingCities"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md6 pa-1>
                                        <v-text-field
                                            prepend-inner-icon="fas fa-address-card"
                                            v-model="address"
                                            :rules="rules.address"
                                            label="Dirección"
                                            outline
                                        />
                                    </v-flex>
                                    <v-flex xs12 md6 pa-1>
                                        <v-text-field
                                            prepend-inner-icon="fas fa-industry"
                                            v-model="businessSector"
                                            :rules="rules.businessSector"
                                            label="Giro"
                                            outline
                                        />
                                    </v-flex>
                                    <v-flex xs12 px-1>
                                        <v-alert type="error" icon="info" outline style="padding: 4px 8px; border-radius: 4px" :value="!hasLiorenToken">
                                            Para la emisión de boletas electronicas debe comunicarse con <a href="mailto:contacto@medapp.cl">contacto@medapp.cl</a>
                                        </v-alert>
                                    </v-flex>
                                    <v-flex xs12 pa-1>
                                        <v-text-field
                                            hide-details outline
                                            label="LIOREN TOKEN"
                                            :rules="rules.token"
                                            v-model="lioren_token"
                                            prepend-inner-icon="mdi-key-outline"
                                        />
                                    </v-flex>
                                    <v-flex xs12 text-xs-right>
                                        <v-btn
                                            :loading="loadingSave"
                                            :disabled="!validForm"
                                            color="primary"
                                            @click="saveData"
                                        >
                                            Guardar
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>

                    </v-card>

                    <v-alert v-else :value="true" type="info" outline color="secondary" class="body-1">
                        Solo el dueño de la cuenta puede revisar la subscripción
                    </v-alert>

                    <plan-picker ref="planPicker" @plan:purchased="onPlanPurchased"/>
                </v-flex>
            </v-layout>
        </v-card>
        <v-dialog v-model="subscriptionCancelDialog" max-width="500" persistent>
            <v-card>
                <v-card-title>
                    <div class="title">Cancelar Subscripción</div>
                    <v-spacer></v-spacer>
                    <v-btn flat fab small @click="subscriptionCancelDialog = false" :disabled="cancellingSubscription">
                        <v-icon>fa-times</v-icon>
                    </v-btn>

                </v-card-title>
                <v-card-text class="pt-0">
                    ¿Seguro(a) que deseas cancelar la subscripción actual?. Tu cuenta será suspendida, pero puedes
                    volver a contratar un plan cuando lo necesites.
                    <v-checkbox ripple v-model="removeCC" label="Eliminar medio de pago" persistent-hint
                                hint="* Puedes mantener tu medio de pago para cuando vuelvas a contratar"/>
                    <v-alert type="info" color="secondary" class="mb-2" outline :value="true"
                             v-if="currentSubscription && Number(currentSubscription.status) === 2">
                        Al cancelar tu subscripción, perderás tus días de prueba.
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="cancellingSubscription" @click="subscriptionCancelDialog = false" depressed>No
                    </v-btn>
                    <v-btn @click="cancelCurrentSubscription" :loading="cancellingSubscription" color="error">Sí,
                        Cancelar subscripción
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>
<script>

import {ApiUtils} from '@/utils/ApiUtils'
import ProviderTitle from "@/components/providers/panel/ProviderTitle";
import ProviderSubTitle from "@/components/providers/panel/ProviderSubTitle";
import PlanPicker from "../../subscription/PlanPicker";

import {mapGetters, mapState} from 'vuex';
import CreditCard from "@/components/payment/CreditCard";
import CardRegistrationButton from "@/components/subscription/CardRegistrationButton";
import {rutFormat, rutValidator} from "@/utils/Common";

export default {
    components: {CardRegistrationButton, CreditCard, PlanPicker, ProviderSubTitle, ProviderTitle},
    props: {
        needScroll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            subscriptionCancelDialog: false,
            cancellingSubscription: false,
            removeCC: false,
            refreshingPaymentData: false,
            dni: '',
            businessName: '',
            cities: [],
            city: null,
            communes: [],
            commune: null,
            address: '',
            businessSector: '',
            hasLiorenToken: false,
            lioren_token: '',
            rules: {
                dni: [
                    v => !!v || 'El RUT es obligatorio',
                    rutValidator
                ],
                businessName: [
                    v => !!v || 'La Razón Social es obligatoria',
                    v => v.length >= 5 || 'El mínimo de caracteres es 5',
                    v => v.length <= 100 || 'El máximo de caracteres es 100',
                ],
                city: [
                    v => !!v || 'La Ciudad es obligatoria',
                ],
                commune: [
                    v => !!v || 'La Comuna es obligatoria',
                ],
                address: [
                    v => !!v || 'La Dirección es obligatoria',
                    v => v.length >= 5 || 'El mínimo de caracteres es 5',
                    v => v.length <= 50 || 'El máximo de caracteres es 50',
                ],
                businessSector: [
                    v => !!v || 'El Giro es obligatorio',
                    v => v.length >= 5 || 'El mínimo de caracteres es 5',
                    v => v.length <= 40 || 'El máximo de caracteres es 40',
                ],
                token: [
                    v => !!v || 'El token es obligatorio',
                ],
            },
            loadingCities: false,
            loadingSave: false,
            validForm: false,
        }
    },
    async mounted() {
        const vm = this
        if (vm.currentProvider && vm.currentProvider.should_refresh_payment_data) await vm.refreshPaymentData()
        await vm.getCities()
        vm.loadSubscriptionData()
        if (vm.needScroll) vm.scrollToBottom()
    },
    computed: {
        ...mapState(['currentProvider']),
        ...mapGetters([
            'currentProviderName',
            'currentSubscription',
            'subscribedPlan',
            'subscriptionWasCancelled',
            'paymentFailed',
            'planPurchaseNeeded'
        ]),
        subscribedAt() {
            const vm = this
            if (!vm.currentSubscription) return null
            return vm.$moment(vm.currentSubscription.created_at)
                .format('ddd DD MMMM, YYYY.')
        },
        subscriptionStatus() {
            const vm = this
            if (!vm.currentSubscription) {
                return {
                    text: 'Sin Subscripción',
                    help: 'Aún no contratas un plan',
                    color: 'grey'
                }
            }

            let status = {
                text: '',
                help: '',
                color: ''
            };

            switch (Number(vm.currentSubscription.status)) {
                case 1:
                    status.text = 'Activa'
                    status.help = 'Tu plan no presenta problemas'
                    status.color = 'success'
                    break
                case 2:
                    status.text = 'Periodo de prueba extendido'
                    status.help = 'Estás en tu periodo de prueba extendido, no habrán cobros aún :)'
                    status.color = 'secondary'
                    break
                case 3:
                    status.text = 'Cancelada'
                    status.help = 'Tu subscripción ha sido cancelada. Contrata un plan para continuar utilizando kim'
                    status.color = 'error'
                    break
                default:
                    status.text = 'Inactivo'
                    status.help = ''
                    status.color = 'grey'
            }

            return status

        },
        card() {
            const vm = this
            if (!vm.currentProvider || !vm.currentProvider.card_last4_digits) {
                return null
            }

            return {
                last4Digits: vm.currentProvider.card_last4_digits,
                holder: vm.currentProviderName,
                type: vm.currentProvider.card_type || 'Visa'
            }
        }
    },
    methods: {
        async refreshPaymentData() {
            const vm = this
            if (vm.refreshingPaymentData || !vm.currentProvider) return

            vm.refreshingPaymentData = true
            const endpoint = `providers/${vm.currentProvider.id}/customer/refresh`
            const response = await ApiUtils.makeGet(endpoint)

            if (response.ok) {
                await vm.refreshMe()
            }

            vm.refreshingPaymentData = false

        },
        async onPlanPurchased() {
            const vm = this
            await vm.refreshMe()
            vm.toast('Plan contratado exitosamente')
        },
        async refreshMe() {
            await ApiUtils.fetchMe()
        },
        async cancelCurrentSubscription() {
            const vm = this
            if (vm.cancellingSubscription || !vm.currentProvider) return

            vm.cancellingSubscription = true
            const endpoint = vm.removeCC ?
                `providers/${vm.currentProvider.id}/subscription/reset` :
                `providers/${vm.currentProvider.id}/subscription/cancel`
            const response = await ApiUtils.makePost(endpoint)

            if (!response.ok) {
                vm.cancellingSubscription = false
                const json = await response.json()
                return vm.toast(json.message || 'Ocurrió un error cancelando la subscripción', 'error')
            }

            await ApiUtils.fetchMe();
            vm.cancellingSubscription = false
            vm.subscriptionCancelDialog = false
            return vm.toast('Subscripción cancelada exitosamente')
        },
        async getCities() {
            const vm = this
            vm.loadingCities = true
            let response = await ApiUtils.makeGet('public/communes')
            const json = await response.json()
            vm.cities = json.result.cities
            vm.communes = json.result.communes
            vm.loadingCities = false
        },
        async saveData() {
            const vm = this
            vm.loadingSave = true

            let payload = {
                dni: vm.dni.trim().replace(/\./g, '').replace('-', ''),
                business_name: vm.businessName,
                business_sector: vm.businessSector,
                commune: vm.commune.id,
                city: vm.city.id,
                address: vm.address,
                lioren_token: vm.lioren_token,
            }

            let response = await ApiUtils.makePost(`subscriptions/${vm.currentSubscription.id}/billing-data`, payload)
            await vm.refreshMe()
            vm.loadingSave = false

            let color = response.ok ? 'success' : ''
            vm.showSnackBar({text: response.ok ? 'Datos guardados' : 'Ha ocurrido un error', color})
        },
        loadSubscriptionData() {
            const vm = this
            if (!vm.currentSubscription) return;
            vm.dni = vm.currentSubscription.dni || ''
            vm.businessName = vm.currentSubscription.business_name || ''
            vm.businessSector = vm.currentSubscription.business_sector || ''
            vm.commune = vm.communes.find(commune => commune.id === vm.currentSubscription.commune) || null
            vm.city = vm.cities.find(city => city.id === vm.currentSubscription.city) || null
            vm.address = vm.currentSubscription.address || ''
            vm.lioren_token = vm.currentSubscription.lioren_token || ''
            vm.hasLiorenToken = vm.lioren_token
        },
        scrollToBottom() {
            window.scrollTo({
                top: document.body.scrollHeight - window.innerHeight,
                behavior: 'smooth'
            })
        }
    },
    watch: {
        dni(val) {
            this.dni = rutFormat(val)
        },
        commune(val) {
            if (typeof (val) === 'string') this.commune = null
        },
        needScroll(val) {
            if (val) this.scrollToBottom()
        }
    },
}
</script>
